<template>
  <popup
    :opened="showHelp"
    @close="close"
  >
    <message-header :message-header="messageHeader" />

    <div class="min-h-screen p-5 md:p-10 xl:p-15 2xl:p-20 w-full">
      <form class="w-full">
        <h2 class="text-3xl text-gray-900 mt-20 mb-10 font-normal uppercase">
          Contact
        </h2>

        <div class="text-center">
          <p
            v-if="$subscribed()"
            class="mb-10 text-lg text-indigo-600"
          >
            Pour obtenir de l’aide, vous pouvez nous contacter par téléphone :
          </p>

          <a
            v-if="$subscribed()"
            :href="hrefTel"
            class="text-pink-600 text-3xl"
          >{{ tel }}</a>

          <p
            v-if="$subscribed()"
            class="text-lg text-indigo-600 mt-10"
          >
            Ou via le formulaire de contact ci-dessous.
          </p>
          <p
            v-else
            class="text-lg text-indigo-600 mt-10"
          >
            Pour obtenir de l’aide, vous pouvez nous contacter via le formulaire de contact ci-dessous.
          </p>
        </div>

        <div class="my-10 w-full">
          <div class="grid grid-cols-12 gap-x-4 gap-y-5">
            <input-text
              class="lg:col-span-6"
              required="required"
              name="firstname"
              libelle="Prénom"
              :value="form.firstname"
              @input="
                (newValue) => {
                  form.firstname = newValue;
                }
              "
              :error="true"
              :msg-error="(errors.firstname || [])[0] || ''"
              @focusInput="(errors.firstname || [])[0] = ''"
            />
            <input-text
              class="lg:col-span-6"
              required="required"
              name="lastname"
              libelle="Nom"
              :value="form.lastname"
              @input="
                (newValue) => {
                  form.lastname = newValue;
                }
              "
              :error="true"
              :msg-error="(errors.lastname || [])[0] || ''"
              @focusInput="(errors.lastname || [])[0] = ''"
            />
            <input-text
              class="lg:col-span-6"
              required="required"
              name="company"
              libelle="Entreprise"
              :value="form.company"
              @input="
                (newValue) => {
                  form.company = newValue;
                }
              "
              :error="true"
              :msg-error="(errors.company || [])[0] || ''"
              @focusInput="(errors.company || [])[0] = ''"
            />
            <input-text
              class="lg:col-span-6"
              name="function"
              libelle="Fonction"
              :value="form.function"
              @input="
                (newValue) => {
                  form.function = newValue;
                }
              "
            />
            <input-text
              class="lg:col-span-6"
              required="required"
              name="email"
              type="email"
              libelle="Email"
              :value="form.email"
              @input="
                (newValue) => {
                  form.email = newValue;
                }
              "
              :error="true"
              :msg-error="(errors.email || [])[0] || ''"
              @focusInput="(errors.email || [])[0] = ''"
            />
            <input-text
              class="lg:col-span-6"
              required="required"
              name="phone_number"
              libelle="Téléphone"
              :value="form.phone_number"
              @input="
                (newValue) => {
                  form.phone_number = newValue;
                }
              "
              type="tel"
              :error="true"
              :msg-error="(errors.phone_number || [])[0] || ''"
              @focusInput="(errors.phone_number || [])[0] = ''"
            />
            <input-select
              name="typeDemande"
              class="lg:col-span-6"
              libelle="Type de demande"
              :datas="listeTypesDemande"
              :value="form.typeDemande"
              @input="
                (newValue) => {
                  form.typeDemande = newValue;
                }
              "
              :required="true"
              :error="true"
              :msg-error="(errors.typeDemande || [])[0] || ''"
              @focusInput="(errors.typeDemande || [])[0] = ''"
            />
            <input-text-area
              class="lg:col-span-full"
              size="5"
              name="message"
              libelle="Message"
              :value="form.message"
              @input="
                (newValue) => {
                  form.message = newValue;
                }
              "
              :required="true"
              :error="true"
              :msg-error="(errors.message || [])[0] || ''"
              @focusInput="(errors.message || [])[0] = ''"
            />

            <div
              class="flex justify-center md:justify-end w-full col-span-full"
            >
              <action-button
                class="mt-10"
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="Envoyer"
                :uppercase="true"
                icon="plane"
                type-shadow="shadow-pink"
                :right="true"
                :spinner="sending"
                @clickAction="sendForm"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </popup>
</template>

<script>
import axios from './../../../api';
import InputText from './../../../components/Inputs/InputText';
import InputSelect from '../../../components/Inputs/InputSelect';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import Popup from '../../../components/Popup';
import ActionButton from '../../../components/ActionButton';
import MessageHeader from '../../../components/MessageHeader';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Help',

  components: {
    InputText,
    InputSelect,
    InputTextArea,
    Popup,
    ActionButton,
    MessageHeader,
  },

  props: {
    showHelp: Boolean,
  },

  data() {
    return {
      errors: {
        phone_number: [],
        email: [],
      },
      tel: '06 33 01 76 16',
      sending: false,
      form: {
        firstname: '',
        lastname: '',
        email: '',
        phone_number: '',
        company: '',
        function: '',
        typeDemande: '',
        message: '',
      },
      listeTypesDemande: [
        {
          value: 'Conseil technique',
        },
        {
          value: 'Facturation et commande',
        },
        {
          value: 'Incident',
        },
      ],
    };
  },

  created() {
    this.$store.commit('help/SET_MESSAGEHEADER', null);
    this.initForm();
  },

  methods: {
    ...mapMutations({
      SET_MESSAGEHEADER: 'help/SET_MESSAGEHEADER',
    }),

    close() {
      this.$emit('close');
    },

    async sendForm() {
      if (!this.form.phone_number || this.form.phone_number === '') {
        this.errors.phone_number.push(
          'Veuillez renseigner un numéro de téléphone'
        );
        return;
      }

      if (
        !/^\d+$/.test(this.form.phone_number.replaceAll(/\s/g, '')) ||
        this.form.phone_number.replaceAll(/\s/g, '').length != 10
      ) {
        this.errors.phone_number.push(
          'Le numéro de téléphone n\'est pas au bon format'
        );
        return;
      } else if (
        !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.form.email
        )
      ) {
        this.errors.email.push('L\'adresse mail n\'est pas au bon format');
        return;
      }

      this.sending = true;
      this.SET_MESSAGEHEADER(null);

      try {
        const { data } = await axios.post('/api/contact/send', this.form);

        if (data.sent) {
          this.initForm();
          this.SET_MESSAGEHEADER({
            type: 'success',
            msg: 'Votre message a bien été envoyé. Un membre de l\'équipe Neopass vous répondra dans les meilleures délais.',
          });
          setTimeout(() => {
            this.SET_MESSAGEHEADER(null);
          }, 3000);
        }
      } catch (err) {
        const error = err.response ? err.response.data : err;

        this.errors = { ...this.errors, ...error.errors };

        this.SET_MESSAGEHEADER({
          type: 'error',
          msg: `Impossible d'envoyer le message (${
            error.errors
              ? Object.values(error.errors).join(', ')
              : error.message
          }). Veuillez réessayer`,
        });
        setTimeout(() => {
          this.SET_MESSAGEHEADER(null);
        }, 3000);
      } finally {
        this.sending = false;
      }
    },

    initForm() {
      this.form.message = '';
      this.form.username = '';
      this.form.firstname = '';
      this.form.lastname = '';
      this.form.company = '';
      this.form.email = '';
      this.form.phone_number = '';
    },
  },

  computed: {
    ...mapGetters({
      messageHeader: 'help/messageHeader',
      user: 'auth/user',
    }),

    hrefTel() {
      return `tel:${this.tel}`;
    },
  },
};
</script>
